export const BLOCKED_FILE_ICON_CSS: string = 'fileType-icon-blockedfile_32x32';
export const GENERIC_CLASSIC_FILE_ICON_CSS: string = 'fileType-icon-generic_32x32';
